const mmMedium = typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)');
const mmMLarge = typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)');

export function checkMobileDeviceWidth() {
  if (mmMedium.matches === true) {
    // desktop actions
    return 'desktop';
  } if (mmMedium.matches === false) {
    // mobile actions
    return 'mobile';
  }
}

export function checkDesktopLargeDeviceWidth() {
  if (mmMLarge.matches === true) {
    // desktop >= large actions
    return true;
  } if (mmMLarge.matches === false) {
    // desktop < large actions
    return false;
  }
}
